/* Muk email-entry discount support.
 * A link containing ?muk_discount=CODE is redirected once to Shopify's
 * native /discount/CODE route, which sets the discount on Shopify's side.
 * Existing drawer/manual coupon entry continues to work unchanged.
 */
(function () {
  'use strict';
  if (!window.URLSearchParams || !window.location || !window.history) return;
  var query = new URLSearchParams(window.location.search);
  var code = (query.get('muk_discount') || '').trim();
  if (!code) return;
  // Allow standard printable discount codes only; never treat a URL as a code.
  if (code.length > 128 || !/^[A-Za-z0-9][A-Za-z0-9_\-]*$/.test(code)) {
    query.delete('muk_discount');
    var invalid = window.location.pathname + (query.toString() ? '?' + query.toString() : '') + window.location.hash;
    window.history.replaceState(window.history.state, '', invalid);
    return;
  }
  query.delete('muk_discount');
  // Keep campaign attribution and unpublished-theme preview parameters.
  var returnTo = window.location.pathname + (query.toString() ? '?' + query.toString() : '') + window.location.hash;
  var route = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(returnTo);
  window.location.replace(route);
}());
